"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _react = _interopRequireWildcard(require("react"));
var _bankingDriver = _interopRequireDefault(require("./banking-driver"));
var BankingDrivers = function BankingDrivers(_ref) {
  var drivers = _ref.drivers,
    isLimitedTimeOffer = _ref.isLimitedTimeOffer;
  var renderDrivers = drivers.map(function (driver, index) {
    var lastIndex = drivers.length - 1;
    return /*#__PURE__*/_react.default.createElement(_bankingDriver.default, {
      driver: driver,
      renderDivider: index !== lastIndex,
      isLimitedTimeOffer: isLimitedTimeOffer
    });
  });
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderDrivers);
};
var _default = BankingDrivers;
exports.default = _default;